import React from 'react';
import { motion } from 'framer-motion';
import { useCountdown } from '../hooks/useCountdown';
export function AnnouncementBar() {
  const {
    formatted,
    isUrgent
  } = useCountdown(14, 8);
  return <div className="fixed top-0 left-0 right-0 z-50 bg-[#CC0000] text-white py-1.5 md:py-2.5 px-2 md:px-4 text-center text-xs md:text-base font-bold shadow-lg" data-id="element-13">
      <div className="max-w-5xl mx-auto flex flex-row justify-center items-center gap-1.5 md:gap-3 flex-wrap" data-id="element-14">
        <span className="text-white leading-tight" data-id="element-15">
          🔥{' '}
          <span className="hidden sm:inline" data-id="element-16">
            FLASH SALE: Get The Backyard Pitmaster for just
          </span>
          <span className="sm:hidden" data-id="element-17">FLASH SALE:</span> $6.36 —{' '}
          <span className="text-[#F2B851]" data-id="element-18">63% OFF</span>
        </span>
        <motion.span animate={isUrgent ? {
        color: ['#F2B851', '#FFFFFF', '#F2B851']
      } : {}} transition={{
        duration: 1,
        repeat: Infinity
      }} className="font-mono bg-[rgba(0,0,0,0.4)] text-[#F2B851] px-3 py-1 rounded tracking-wider text-xs md:text-base" data-id="element-19">
          {formatted}
        </motion.span>
        <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      })} className="bg-gradient-to-r from-[#F2B851] to-[#C45F2A] text-[#0F1111] font-black uppercase text-xs px-4 py-1.5 rounded hover:brightness-110 transition-all" data-id="element-20">
          CLAIM 63% OFF
        </button>
      </div>
    </div>;
}